import { useCallback, useRef, useState } from 'react';

export default function usePopoverEdgeAlign(contentWidth: number, margin = 16) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [align, setAlign] = useState<'start' | 'end'>('start');

  const updateAlign = useCallback(() => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;

    setAlign(window.innerWidth - rect.left < contentWidth + margin ? 'end' : 'start');
  }, [contentWidth, margin]);

  return { triggerRef, align, updateAlign };
}
